import script from "./UnderWriteMeIntegration.vue?vue&type=script&setup=true&lang=js"
export * from "./UnderWriteMeIntegration.vue?vue&type=script&setup=true&lang=js"

import "./UnderWriteMeIntegration.vue?vue&type=style&index=0&id=0abe3558&scoped=true&lang=css"
import "./UnderWriteMeIntegration.vue?vue&type=style&index=1&id=0abe3558&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0abe3558"]])

export default __exports__